import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c64adb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar Planilha", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Importar Títulos", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_7 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn",
  style: {"min-height":"200px!important"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ant-upload-drag-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-upload-drag-icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste o arquivo excel até aqui.", -1))
const _hoisted_14 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = { key: 7 }
const _hoisted_22 = { key: 8 }
const _hoisted_23 = {
  key: 9,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Competência:", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Baixa:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Juros/Multa:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Acréscimo:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Desconto:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Saldo:", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 10 }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_43 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_44 = { class: "ant-col ant-col-xs-10 ant-col-xl-12" }
const _hoisted_45 = { class: "ant-col ant-col-xs-10 ant-col-xl-12" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-21 ant-col-xl-21" }, null, -1))
const _hoisted_48 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: 'Importação de Contas a ' + (_ctx.props.tipoTitulo == 1? 'Pagar' : 'Receber') + ' pelo Excel',
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-financeiro"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.baixarArquivo && _ctx.baixarArquivo(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importarTitulos && _ctx.importarTitulos(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.state.cacheDisponivel)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    style: {"width":"100%"},
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui a importação do arquivo: " + _toDisplayString(_ctx.state.nomeArquivo) + " em andamento, deseja recuperar? ", 1),
                      _createVNode(_component_a_button, {
                        onClick: _ctx.recuperarCache,
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "ss-accordion",
              activeKey: _ctx.state.painelUpload,
              "onUpdate:activeKey": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.painelUpload) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: "Envie um arquivo"
                }, {
                  default: _withCtx(() => [
                    (_ctx.modalBase.computedVisivel)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                          class: "ant-upload ant-upload-drag",
                          onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_7, [
                            _createElementVNode("input", {
                              id: "selecionarArquivo",
                              type: "file",
                              accept: "",
                              multiple: "",
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoSelecionado && _ctx.uploadArquivoSelecionado(...args))),
                              style: {"display":"none"}
                            }, null, 32),
                            _createElementVNode("div", {
                              class: "ant-upload-drag-container",
                              onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoArrastado && _ctx.uploadArquivoArrastado(...args)))
                            }, [
                              ((_ctx.state.enviandoArquivo))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("p", _hoisted_9, [
                                      _createVNode(_component_a_spin, { size: "large" })
                                    ]),
                                    _hoisted_10
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("p", _hoisted_12, [
                                      _createVNode(_component_icone, {
                                        style: {"font-size":"40px"},
                                        nome: "upload-nuvem"
                                      })
                                    ]),
                                    _hoisted_13
                                  ]))
                            ], 32)
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          (_ctx.state.titulos.length > 0 && !_ctx.state.enviandoArquivo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_form_item, {
                    label: "Busca Rápida",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                        onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.verificarFiltro && _ctx.verificarFiltro(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.buscaRapida]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_card, { titulo: "Títulos no Arquivo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.titulos.filter(i => i.visivel),
                        rowKey: "index",
                        pagination: false,
                        loading: _ctx.telaBase.carregando,
                        scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150), y: _ctx.window.innerHeight - 500 },
                        "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'NumeroTitulo')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!record.validado)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      placement: "top",
                                      title:  record.mensagemValidacao 
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, {
                                          style: {"color":"orangered"},
                                          class: "ss-icone-informacao-campo",
                                          nome: "informacao-campo"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'Status')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                ((record.pessoaRepasse > 0 && (record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente)))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_a_tag, {
                                        title: "Repassado",
                                        class: "ss-tag-status baixado"
                                      }),
                                      _createTextVNode("Repassado ")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_a_tag, {
                                        title: text,
                                        class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(text))
                                      }, null, 8, ["title", "class"]),
                                      _createTextVNode(_toDisplayString(text), 1)
                                    ], 64))
                              ], 64))
                            : (column.key === 'CpfCnpjPessoa')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1),
                                  (!_ctx.UtilitarioGeral.validaCodigo(record.codigoPessoa))
                                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                        key: 0,
                                        placement: "top",
                                        title: "Pessoa não encontrada com o CPF/CNPJ indicado!"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icone, {
                                            style: {"color":"orangered"},
                                            class: "ss-icone-informacao-campo",
                                            nome: "informacao-campo"
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (column.key === 'NumeroTitulo')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createElementVNode("span", null, _toDisplayString(text), 1),
                                    (_ctx.UtilitarioGeral.validaCodigo(record.codigo))
                                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                          key: 0,
                                          placement: "top",
                                          title: "Já existe um título lançado com esse número de título!"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_icone, {
                                              style: {"color":"orangered"},
                                              class: "ss-icone-informacao-campo",
                                              nome: "informacao-campo"
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (column.key === 'DataBaixa')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      (record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.AprovacaoPendente)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                    ], 64))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                          : (column.key === 'TituloFinanceiro')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createElementVNode("span", null, [
                                                  _hoisted_24,
                                                  _createTextVNode(_toDisplayString(record.numeroTitulo), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_25,
                                                  _createTextVNode(_toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_26,
                                                  _createTextVNode(_toDisplayString(record.dataVencimentoFormatada), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_27,
                                                  _createTextVNode(_toDisplayString(record.dataCompetencia), 1)
                                                ]),
                                                (record.status !== _ctx.EStatusTituloFinanceiro.Pendente)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                      _hoisted_29,
                                                      _createTextVNode(_toDisplayString(record.dataBaixa), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("span", null, [
                                                  _hoisted_30,
                                                  _createTextVNode(_toDisplayString(record.nomePessoa), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_31,
                                                  _createTextVNode(_toDisplayString(record.descricaoConta), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_32,
                                                  _createTextVNode(_toDisplayString(record.nomePlanoContaCategoria), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_33,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_34,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.jurosMulta,2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_35,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.acrescimo,2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_36,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.desconto,2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_37,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2)), 1)
                                                ]),
                                                ((record.pessoaRepasse > 0 && record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                      _createVNode(_component_a_tag, {
                                                        title: "Repassado",
                                                        class: "ss-tag-status baixado"
                                                      }),
                                                      _createTextVNode("Repassado")
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                                      _createVNode(_component_a_tag, {
                                                        title: text,
                                                        class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(record.descricaoStatus))
                                                      }, null, 8, ["title", "class"]),
                                                      _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                                                    ]))
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(text), 1))
                        ]),
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, {
                            resultadoPesquisa: !_ctx.telaBase.carregando,
                            mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                          }, null, 8, ["resultadoPesquisa", "mensagem"])
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, { titulo: "Ajustes" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Documento",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                "codigo-selecionado": _ctx.state.codigotipoDocumentoSelecionado,
                                "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.codigotipoDocumentoSelecionado) = $event)),
                                "descricao-selecionado": _ctx.state.descricaoTipoDocumentoSelecionado,
                                "onUpdate:descricaoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.descricaoTipoDocumentoSelecionado) = $event)),
                                empresas: [_ctx.props.empresa]
                              }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_a_form_item, {
                            label: "Pessoa",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_pessoa, {
                                "codigo-selecionado": _ctx.state.codigoPessoa,
                                "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.codigoPessoa) = $event)),
                                "nome-selecionado": _ctx.state.nomePessoa,
                                "onUpdate:nomeSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.nomePessoa) = $event)),
                                empresas: [_ctx.props.empresa]
                              }, null, 8, ["codigo-selecionado", "nome-selecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_selecionar_conta, {
                            "codigo-selecionado": _ctx.state.codigoConta,
                            "onUpdate:codigoSelecionado": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.codigoConta) = $event)),
                            "descricao-selecionado": _ctx.state.descricaoConta,
                            "onUpdate:descricaoSelecionado": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.descricaoConta) = $event)),
                            empresas: [_ctx.props.empresa]
                          }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                "codigo-selecionado": _ctx.state.codigoCategoria,
                                "onUpdate:codigoSelecionado": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.codigoCategoria) = $event)),
                                "descricao-selecionado": _ctx.state.nomeCategoria,
                                "onUpdate:descricaoSelecionado": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.nomeCategoria) = $event)),
                                empresas: [_ctx.props.empresa]
                              }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary",
                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.realizarAjustes && _ctx.realizarAjustes(...args))),
                                style: {"width":"100%"}
                              }, "Aplicar Ajustes")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      }),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}